import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisRequest = ApiDefinition['/ai/product-title']['POST'];
type Input = ThisRequest['body'];
type Output = ThisRequest['response'];

const generateProductTitle = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.post('/ai/product-title', payload);
  return response.data;
};

export default generateProductTitle;
